import mapboxManager from "../mapbox_manager"

// Shared marker/popup lifecycle; callers supply domain-specific content and coordinates.
export default class LocationMapMarkers {
  constructor({ map, locationMapId, markerTemplate, popupOptions = {}, onShow = () => {} }) {
    this.map = map
    this.markerTemplate = markerTemplate
    this.popupOptions = popupOptions
    this.onShow = onShow
    this.locations = new Map()
    this.listeners = new AbortController()
    this.markers = []
    this.popups = []
    const mapData = mapboxManager.activeMaps.get(locationMapId)
    if (mapData) Object.assign(mapData, { markers: this.markers, popups: this.popups })
  }

  add({ id, coordinates, title, content }) {
    const element = this.markerTemplate.content.firstElementChild.cloneNode(true)
    element.setAttribute("aria-label", title)
    const marker = mapboxManager.createMarker({ element, anchor: "bottom" })
      .setLngLat(coordinates).addTo(this.map)
    element.setAttribute("role", "button")
    const popup = mapboxManager.createPopup({ maxWidth: "240px", closeOnClick: false, ...this.popupOptions })
      .setDOMContent(content)
    this.markers.push(marker)
    this.popups.push(popup)
    this.locations.set(String(id), { coordinates, popup })
    for (const type of ["click", "mouseenter"]) {
      element.addEventListener(type, () => this.show(id), { signal: this.listeners.signal })
    }
  }

  show(id, flightOptions) {
    const location = this.locations.get(String(id))
    if (!location) return
    if (flightOptions) this.map.flyTo({ center: location.coordinates, duration: 500, ...flightOptions })
    if (this.activePopup !== location.popup) this.close()
    this.activePopup = location.popup
    this.activePopup.setLngLat(location.coordinates).addTo(this.map)
    this.onShow(this.activePopup)
  }

  close() {
    this.activePopup?.remove()
    this.activePopup = null
  }

  destroy() {
    this.listeners.abort()
    this.close()
    this.markers.forEach((marker) => marker.remove())
    this.popups.forEach((popup) => popup.remove())
    this.markers.length = 0
    this.popups.length = 0
    this.locations.clear()
  }
}
